var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head flex f-between f-align-center"},[_c('span',{staticClass:"white"},[_vm._v("\n        设备管理系统\n    ")]),_vm._v(" "),_c('div',{staticClass:"right flex f-align-center"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nick))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-228a4d72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/topHead.vue
// module id = 2pqL
// module chunks = 1